import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Skeleton } from 'primereact/skeleton';
import React, { useState } from 'react';
import CustomDataTable from '../../components/CustomDataTable/CustomDataTable';

const SkeletonDashboard = () => {
    const items = Array.from({ length: 5 }, (v, i) => i);
    return (
        <div className="layout-dashboard additional-dashboard">
            <div className="grid col-12">
                <div className="md:col-3">
                    <div className={`card widget-overview-box widget-overview-box`}>
                        <div className="overview-top">
                            <span className="overview-title">Total Users</span>
                        </div>
                        <div className="flex justify-content-between earning-overview">
                            <div className="overview-detail flex justify-content-between">
                                <div className="overview-badge flex  align-items-center pl-0">
                                    <Skeleton height="30px"></Skeleton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="md:col-3">
                    <div className={`card widget-overview-box widget-overview-box`}>
                        <div className="overview-top">
                            <span className="overview-title">Fresh Registration</span>
                        </div>
                        <div className="flex justify-content-between earning-overview">
                            <div className="overview-detail flex justify-content-between">
                                <div className="overview-badge flex  align-items-center pl-0">
                                    <Skeleton height="30px"></Skeleton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="md:col-3">
                    <div className={`card widget-overview-box widget-overview-box`}>
                        <div className="overview-top">
                            <span className="overview-title">Renew Application</span>
                        </div>
                        <div className="flex justify-content-between earning-overview">
                            <div className="overview-detail flex justify-content-between">
                                <div className="overview-badge flex  align-items-center pl-0">
                                    {' '}
                                    <Skeleton height="30px"></Skeleton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="md:col-3">
                    <div className={`card widget-overview-box widget-overview-box`}>
                        <div className="overview-top">
                            <span className="overview-title">Re-Entry Application</span>
                        </div>
                        <div className="flex justify-content-between earning-overview">
                            <div className="overview-detail flex justify-content-between">
                                <div className="overview-badge flex  align-items-center pl-0">
                                    {' '}
                                    <Skeleton height="30px"></Skeleton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid col-12">
                <div className="col-8 ">
                    <div className="card">
                        <div className="card-header mb-2">
                            <span className="overview-text-h">Application</span>
                            <Skeleton width="215px" height="30px"></Skeleton>
                            {/* <Calendar value={applicationYear} onChange={(e) => setApplicationYear(e.value)} view="year" dateFormat="yy" showIcon /> */}
                        </div>
                        <div className="graph">
                            {/* <Chart type="line" id="revenue-chart" data={totalOrderData} options={totalOrderOptions}></Chart> */}
                            <Skeleton height="280px"></Skeleton>
                        </div>
                    </div>
                </div>
                <div className="col-4">
                    <div className="card widget-timeline">
                        <div className="timeline-header flex justify-content-between align-items-center">
                            <p className="title">Transaction history</p>
                        </div>
                        <div className="timeline-content px-3 pb-3">
                            {/* <Timeline value={visibleEvents} marker={marker} content={content} className="custimized-timeline" /> */}
                            <Skeleton height="250px"></Skeleton>
                        </div>
                        <div className="timeline-footer flex align-items-center justify-content-center"></div>
                    </div>
                </div>
            </div>

            <div className="grid col-12">
                <div className="col-4">
                    <div className="card widget-country-graph">
                        <div className="country-title title">Pending Applications</div>
                        <div className="country-graph px-3 flex justify-content-center">
                            {/* <Chart type="doughnut" id="country-chart" data={countryChart} options={countryChartOptions} style={{ position: 'relative', width: '75%' }}></Chart> */}
                            <Skeleton height="250px"></Skeleton>
                        </div>
                        <div className="country-content">
                            <ul>
                                <li className="flex justify-content-between align-items-center">
                                    <div className="flex justify-content-between align-items-center">
                                        <div
                                            className="color"
                                            style={{
                                                backgroundColor: '#00D0DE',
                                                boxShadow: '0px 0px 10px rgba(0, 208, 222, 0.3)'
                                            }}
                                        ></div>
                                        <span>Fresh Registration</span>
                                    </div>
                                    <span>
                                        <Skeleton width="60px" height="30px"></Skeleton>
                                    </span>
                                </li>
                                <li className="flex justify-content-between align-items-center">
                                    <div className="flex justify-content-between align-items-center">
                                        <div
                                            className="color"
                                            style={{
                                                backgroundColor: '#873EFE',
                                                boxShadow: '0px 0px 10px rgba(135, 62, 254, 0.3)'
                                            }}
                                        ></div>
                                        <span>Fresh Registration Other</span>
                                    </div>
                                    <span>
                                        <Skeleton width="60px" height="30px"></Skeleton>
                                    </span>
                                </li>
                                <li className="flex justify-content-between align-items-center">
                                    <div className="flex justify-content-between align-items-center">
                                        <div
                                            className="color"
                                            style={{
                                                backgroundColor: '#FC6161',
                                                boxShadow: '0px 0px 10px rgba(252, 97, 97, 0.3)'
                                            }}
                                        ></div>
                                        <span>Transfer To Gujarat</span>
                                    </div>
                                    <span>
                                        <Skeleton width="60px" height="30px"></Skeleton>
                                    </span>
                                </li>
                                <li className="flex justify-content-between align-items-center">
                                    <div className="flex justify-content-between align-items-center">
                                        <div
                                            className="color"
                                            style={{
                                                backgroundColor: '#EEE500',
                                                boxShadow: '0px 0px 10px rgba(238, 229, 0, 0.3)'
                                            }}
                                        ></div>
                                        <span>Renew Application</span>
                                    </div>
                                    <span>
                                        <Skeleton width="60px" height="30px"></Skeleton>
                                    </span>
                                </li>
                                <li className="flex justify-content-between align-items-center">
                                    <div className="flex justify-content-between align-items-center">
                                        <div
                                            className="color"
                                            style={{
                                                backgroundColor: '#EC4DBC',
                                                boxShadow: '0px 0px 10px rgba(236, 77, 188, 0.3)'
                                            }}
                                        ></div>
                                        <span>Re-Entry Application</span>
                                    </div>
                                    <span>
                                        <Skeleton width="60px" height="30px"></Skeleton>
                                    </span>
                                </li>
                                <li className="flex justify-content-between align-items-center">
                                    <div className="flex justify-content-between align-items-center">
                                        <div
                                            className="color"
                                            style={{
                                                backgroundColor: '#0F8BFD',
                                                boxShadow: '0px 0px 10px rgba(15, 139, 253, 0.3)'
                                            }}
                                        ></div>
                                        <span>Elligible Application</span>
                                    </div>
                                    <span>
                                        <Skeleton width="60px" height="30px"></Skeleton>
                                    </span>
                                </li>
                                <li className="flex justify-content-between align-items-center">
                                    <div className="flex justify-content-between align-items-center">
                                        <div className="color" style={{ backgroundColor: '#545C6B' }}></div>
                                        <span>Address Change</span>
                                    </div>
                                    <span>
                                        <Skeleton width="60px" height="30px"></Skeleton>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="col-8 data-table-activites ">
                    <div className="section-left">
                        <div className="card up-title title">Upcoming Refresher Course</div>
                        <DataTable value={items} emptyMessage="No Refresher Course Found">
                            <Column field="start_date" header="Stard Date" body={<Skeleton />}></Column>
                            <Column field="end_date" header="End Date" body={<Skeleton />}></Column>
                            <Column field="college_name" header="College Name" body={<Skeleton />}></Column>
                            <Column field="course_name" header="Course Name" body={<Skeleton />}></Column>
                            <Column field="book_slot" header="Booked Slots" body={<Skeleton />}></Column>
                        </DataTable>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonDashboard;
